const tokens = {
  "animations.backdrop-in": {
    "value": "fade-in 250ms var(--imxNHs)",
    "variable": "var(--eGPTkT)"
  },
  "animations.backdrop-out": {
    "value": "fade-out 200ms var(--fzbDxd)",
    "variable": "var(--fDdQIK)"
  },
  "animations.dialog-in": {
    "value": "slide-in 400ms var(--imxNHs)",
    "variable": "var(--djYxwN)"
  },
  "animations.dialog-out": {
    "value": "slide-out 200ms var(--fzbDxd)",
    "variable": "var(--vtRbc)"
  },
  "animations.drawer-in-left": {
    "value": "slide-in-left 400ms var(--imxNHs)",
    "variable": "var(--fHSlqw)"
  },
  "animations.drawer-out-left": {
    "value": "slide-out-left 200ms var(--fzbDxd)",
    "variable": "var(--dZgDXR)"
  },
  "animations.drawer-in-right": {
    "value": "slide-in-right 400ms var(--imxNHs)",
    "variable": "var(--gCYZLj)"
  },
  "animations.drawer-out-right": {
    "value": "slide-out-right 200ms var(--fzbDxd)",
    "variable": "var(--kyLNdO)"
  },
  "animations.skeleton-pulse": {
    "value": "skeleton-pulse 2s var(--GWuOZ) infinite",
    "variable": "var(--lenXCE)"
  },
  "animations.fade-in": {
    "value": "fade-in 400ms var(--imxNHs)",
    "variable": "var(--cmlixv)"
  },
  "animations.collapse-in": {
    "value": "collapse-in 250ms var(--imxNHs)",
    "variable": "var(--dzpyNa)"
  },
  "animations.collapse-out": {
    "value": "collapse-out 200ms var(--fzbDxd)",
    "variable": "var(--lfrOHr)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--bJeTGz)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--aZLOC)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--jDYzax)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--kMMDaR)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--dyIDQb)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--TtVDs)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--btncja)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--esAhmv)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--dzOvWn)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--fuVfvZ)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--fVBMec)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--mUhz)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--cWTXGg)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--cifMdM)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--goNNlj)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--bPXfWW)"
  },
  "easings.pulse": {
    "value": "cubic-bezier(0.4, 0.0, 0.6, 1.0)",
    "variable": "var(--GWuOZ)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.2, 0.0, 0, 1.0)",
    "variable": "var(--drrWcF)"
  },
  "easings.emphasized-in": {
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1.0)",
    "variable": "var(--imxNHs)"
  },
  "easings.emphasized-out": {
    "value": "cubic-bezier(0.3, 0.0, 0.8, 0.15)",
    "variable": "var(--fzbDxd)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--dywXPJ)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--guQdxN)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--gxQaAd)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--kWjDjq)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--loLyxA)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--eRgJXV)"
  },
  "fontSizes.md": {
    "value": "1rem",
    "variable": "var(--daFrau)"
  },
  "fontSizes.lg": {
    "value": "1.125rem",
    "variable": "var(--gKFLFQ)"
  },
  "fontSizes.xl": {
    "value": "1.25rem",
    "variable": "var(--gFqSQX)"
  },
  "fontSizes.2xl": {
    "value": "1.5rem",
    "variable": "var(--dllMvh)"
  },
  "fontSizes.3xl": {
    "value": "1.875rem",
    "variable": "var(--jaXqkI)"
  },
  "fontSizes.4xl": {
    "value": "2.25rem",
    "variable": "var(--cLogVb)"
  },
  "fontSizes.5xl": {
    "value": "3rem",
    "variable": "var(--izMrAu)"
  },
  "fontSizes.6xl": {
    "value": "3.75rem",
    "variable": "var(--hdlyfR)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--bDBsww)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--fwhTbD)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--lkGdGW)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--dRPRGd)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--dooANa)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--fVSZDc)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--llFanx)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--leEsKL)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--hmvyHR)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--janwPd)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--bvnjIx)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--jrseCf)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--glKTKc)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--knaPyh)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--jwdARF)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--eUSVTv)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--lhSeXO)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--ekeMrS)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--jyTpIu)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--lomeBD)"
  },
  "lineHeights.relaxed": {
    "value": "1.75",
    "variable": "var(--kwMYUX)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--dVGecO)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--dbrZvb)"
  },
  "radii.2xs": {
    "value": "0.0625rem",
    "variable": "var(--cDGfvs)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--ixNmpi)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--dxfumK)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--UXfgJ)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--bphCwb)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--eougbK)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--kkkBVq)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--kTdGYg)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--cCUBeV)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--gsUKim)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--jshnNX)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--juMtMc)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--beDnSR)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--eUDwWi)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--hTQaBT)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--cAmzCM)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--fzzdix)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--dDnfaV)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--cpjPHA)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--ckODEv)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--hTmzdp)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--gANXGP)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--htnoem)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--tQYHK)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--kcGldO)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--gMkTEx)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--lcknGR)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--kveXIc)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--gsriJI)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--bPcliI)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--Mxqsr)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--hZfkST)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--fUWaSi)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--bSilTO)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--fnTGst)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--dAFdyM)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--jxszKr)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--hghuKL)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--drtIxO)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--siblR)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--hSPYxQ)"
  },
  "sizes.4.5": {
    "value": "1.125rem",
    "variable": "var(--fHQhyH)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--czzcgp)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--izvCpj)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--aTIGG)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--kMQJUV)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--dyNKmL)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--ToPgI)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--btoFLe)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--esBjqP)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--hrOPNc)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--krbtsN)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--cRFSXi)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--fQSwCT)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--iQceEA)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--khWApH)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--eOXrSu)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--jNBRbM)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--UhpHH)"
  },
  "sizes.breakpoint-sm": {
    "value": "640px",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "768px",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "1024px",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "1280px",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--jESPPc)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--fcTUxn)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--dacYEG)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--ebuyxV)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--bYDCFo)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--hIimNX)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--fFrqVq)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--gGIQOF)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--eDRUVY)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--flZesP)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--djiiAi)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--ieMJEa)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--cBFxYr)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--uyqLg)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--hXmVPi)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--mYCWo)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--jgejxp)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--iYEvIx)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--fifqnK)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--faFCyS)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--bxwoov)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--huPzrf)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--hgdKvb)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--cZMJbQ)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--iXfUeA)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--vWSpd)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--gtqdrN)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--hNtIEu)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--kqIPsj)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--wdMRQ)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--gEfgCY)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--jJIQbV)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--cqwGG)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--dhUgfD)"
  },
  "spacing.4.5": {
    "value": "1.125rem",
    "variable": "var(--jjtyTI)"
  },
  "zIndex.hide": {
    "value": -1,
    "variable": "var(--eObvFW)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--klLGSj)"
  },
  "zIndex.docked": {
    "value": 10,
    "variable": "var(--cJrNbQ)"
  },
  "zIndex.dropdown": {
    "value": 1000,
    "variable": "var(--TWcuN)"
  },
  "zIndex.sticky": {
    "value": 1100,
    "variable": "var(--eHQPzp)"
  },
  "zIndex.banner": {
    "value": 1200,
    "variable": "var(--dfMdbu)"
  },
  "zIndex.overlay": {
    "value": 1300,
    "variable": "var(--gbwupQ)"
  },
  "zIndex.modal": {
    "value": 1400,
    "variable": "var(--dIktSh)"
  },
  "zIndex.popover": {
    "value": 1500,
    "variable": "var(--beAiOT)"
  },
  "zIndex.skipLink": {
    "value": 1600,
    "variable": "var(--fgvpr)"
  },
  "zIndex.toast": {
    "value": 1700,
    "variable": "var(--BtcyX)"
  },
  "zIndex.tooltip": {
    "value": 1800,
    "variable": "var(--hVmPBT)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--bLinLB)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--qLIrn)"
  },
  "colors.black.a1": {
    "value": "rgba(0, 0, 0, 0.05)",
    "variable": "var(--iydLMu)"
  },
  "colors.black.a2": {
    "value": "rgba(0, 0, 0, 0.1)",
    "variable": "var(--XFXZZ)"
  },
  "colors.black.a3": {
    "value": "rgba(0, 0, 0, 0.15)",
    "variable": "var(--kjwhcg)"
  },
  "colors.black.a4": {
    "value": "rgba(0, 0, 0, 0.2)",
    "variable": "var(--heiKEb)"
  },
  "colors.black.a5": {
    "value": "rgba(0, 0, 0, 0.3)",
    "variable": "var(--faDkhm)"
  },
  "colors.black.a6": {
    "value": "rgba(0, 0, 0, 0.4)",
    "variable": "var(--iPBfTN)"
  },
  "colors.black.a7": {
    "value": "rgba(0, 0, 0, 0.5)",
    "variable": "var(--gLVFwY)"
  },
  "colors.black.a8": {
    "value": "rgba(0, 0, 0, 0.6)",
    "variable": "var(--hAfOQn)"
  },
  "colors.black.a9": {
    "value": "rgba(0, 0, 0, 0.7)",
    "variable": "var(--fwAoty)"
  },
  "colors.black.a10": {
    "value": "rgba(0, 0, 0, 0.8)",
    "variable": "var(--bpOZW)"
  },
  "colors.black.a11": {
    "value": "rgba(0, 0, 0, 0.9)",
    "variable": "var(--bbKKGT)"
  },
  "colors.black.a12": {
    "value": "rgba(0, 0, 0, 0.95)",
    "variable": "var(--dmGdWE)"
  },
  "colors.white": {
    "value": "#ffffff",
    "variable": "var(--RiClf)"
  },
  "colors.white.a1": {
    "value": "rgba(255, 255, 255, 0.05)",
    "variable": "var(--kwgQQu)"
  },
  "colors.white.a2": {
    "value": "rgba(255, 255, 255, 0.1)",
    "variable": "var(--jvERgx)"
  },
  "colors.white.a3": {
    "value": "rgba(255, 255, 255, 0.15)",
    "variable": "var(--fiRAPk)"
  },
  "colors.white.a4": {
    "value": "rgba(255, 255, 255, 0.2)",
    "variable": "var(--kbKMcX)"
  },
  "colors.white.a5": {
    "value": "rgba(255, 255, 255, 0.3)",
    "variable": "var(--fOXvLK)"
  },
  "colors.white.a6": {
    "value": "rgba(255, 255, 255, 0.4)",
    "variable": "var(--eOvwbN)"
  },
  "colors.white.a7": {
    "value": "rgba(255, 255, 255, 0.5)",
    "variable": "var(--BIfKA)"
  },
  "colors.white.a8": {
    "value": "rgba(255, 255, 255, 0.6)",
    "variable": "var(--cBtskn)"
  },
  "colors.white.a9": {
    "value": "rgba(255, 255, 255, 0.7)",
    "variable": "var(--jEbLrW)"
  },
  "colors.white.a10": {
    "value": "rgba(255, 255, 255, 0.8)",
    "variable": "var(--dCzXKm)"
  },
  "colors.white.a11": {
    "value": "rgba(255, 255, 255, 0.9)",
    "variable": "var(--CsgfP)"
  },
  "colors.white.a12": {
    "value": "rgba(255, 255, 255, 0.95)",
    "variable": "var(--icLqJs)"
  },
  "colors.transparent": {
    "value": "rgb(0 0 0 / 0)",
    "variable": "var(--edNtiq)"
  },
  "colors.red.light.1": {
    "value": "#fffcfc",
    "variable": "var(--gJYjos)"
  },
  "colors.red.light.2": {
    "value": "#fff7f7",
    "variable": "var(--fakHyP)"
  },
  "colors.red.light.3": {
    "value": "#feebec",
    "variable": "var(--cEPicq)"
  },
  "colors.red.light.4": {
    "value": "#ffdbdc",
    "variable": "var(--kdBCZd)"
  },
  "colors.red.light.5": {
    "value": "#ffcdce",
    "variable": "var(--hIgdCE)"
  },
  "colors.red.light.6": {
    "value": "#fdbdbe",
    "variable": "var(--fYsBNb)"
  },
  "colors.red.light.7": {
    "value": "#f4a9aa",
    "variable": "var(--dCXcqC)"
  },
  "colors.red.light.8": {
    "value": "#eb8e90",
    "variable": "var(--jDMYit)"
  },
  "colors.red.light.9": {
    "value": "#e5484d",
    "variable": "var(--hiryLU)"
  },
  "colors.red.light.10": {
    "value": "#dc3e42",
    "variable": "var(--kaMCdo)"
  },
  "colors.red.light.11": {
    "value": "#ce2c31",
    "variable": "var(--eVMtoJ)"
  },
  "colors.red.light.12": {
    "value": "#641723",
    "variable": "var(--cyKQJS)"
  },
  "colors.red.light.a1": {
    "value": "#ff000003",
    "variable": "var(--haemQZ)"
  },
  "colors.red.light.a2": {
    "value": "#ff000008",
    "variable": "var(--bwSTPu)"
  },
  "colors.red.light.a3": {
    "value": "#f3000d14",
    "variable": "var(--foUNcH)"
  },
  "colors.red.light.a4": {
    "value": "#ff000824",
    "variable": "var(--dGPPNc)"
  },
  "colors.red.light.a5": {
    "value": "#ff000632",
    "variable": "var(--hyRJap)"
  },
  "colors.red.light.a6": {
    "value": "#f8000442",
    "variable": "var(--bVGpYK)"
  },
  "colors.red.light.a7": {
    "value": "#df000356",
    "variable": "var(--fNIjlX)"
  },
  "colors.red.light.a8": {
    "value": "#d2000571",
    "variable": "var(--eFkFlg)"
  },
  "colors.red.light.a9": {
    "value": "#db0007b7",
    "variable": "var(--ixmyyt)"
  },
  "colors.red.light.a10": {
    "value": "#d10005c1",
    "variable": "var(--ftRbLx)"
  },
  "colors.red.light.a11": {
    "value": "#c40006d3",
    "variable": "var(--gVJEsc)"
  },
  "colors.red.light.a12": {
    "value": "#55000de8",
    "variable": "var(--kTSsSz)"
  },
  "colors.red.dark.1": {
    "value": "#191111",
    "variable": "var(--frGuQq)"
  },
  "colors.red.dark.2": {
    "value": "#201314",
    "variable": "var(--jLsrOR)"
  },
  "colors.red.dark.3": {
    "value": "#3b1219",
    "variable": "var(--iFukOA)"
  },
  "colors.red.dark.4": {
    "value": "#500f1c",
    "variable": "var(--eDGcTz)"
  },
  "colors.red.dark.5": {
    "value": "#611623",
    "variable": "var(--dxHVTi)"
  },
  "colors.red.dark.6": {
    "value": "#72232d",
    "variable": "var(--hRtSRJ)"
  },
  "colors.red.dark.7": {
    "value": "#8c333a",
    "variable": "var(--gLvLRs)"
  },
  "colors.red.dark.8": {
    "value": "#b54548",
    "variable": "var(--TWhgP)"
  },
  "colors.red.dark.9": {
    "value": "#e5484d",
    "variable": "var(--ldtJFu)"
  },
  "colors.red.dark.10": {
    "value": "#ec5d5e",
    "variable": "var(--dsrnHe)"
  },
  "colors.red.dark.11": {
    "value": "#ff9592",
    "variable": "var(--jelFzL)"
  },
  "colors.red.dark.12": {
    "value": "#ffd1d9",
    "variable": "var(--vItRE)"
  },
  "colors.red.dark.a1": {
    "value": "#f4121209",
    "variable": "var(--jlBAob)"
  },
  "colors.red.dark.a2": {
    "value": "#f22f3e11",
    "variable": "var(--gSDHrw)"
  },
  "colors.red.dark.a3": {
    "value": "#ff173f2d",
    "variable": "var(--jgvuNp)"
  },
  "colors.red.dark.a4": {
    "value": "#fe0a3b44",
    "variable": "var(--nMyVq)"
  },
  "colors.red.dark.a5": {
    "value": "#ff204756",
    "variable": "var(--cBEmrj)"
  },
  "colors.red.dark.a6": {
    "value": "#ff3e5668",
    "variable": "var(--iGtuE)"
  },
  "colors.red.dark.a7": {
    "value": "#ff536184",
    "variable": "var(--cwygQx)"
  },
  "colors.red.dark.a8": {
    "value": "#ff5d61b0",
    "variable": "var(--kZYWhK)"
  },
  "colors.red.dark.a9": {
    "value": "#fe4e54e4",
    "variable": "var(--bYvaeH)"
  },
  "colors.red.dark.a10": {
    "value": "#ff6465eb",
    "variable": "var(--lkcTob)"
  },
  "colors.red.dark.a11": {
    "value": "#ff9592",
    "variable": "var(--kvCTcW)"
  },
  "colors.red.dark.a12": {
    "value": "#ffd1d9",
    "variable": "var(--lamoYJ)"
  },
  "colors.gray.light.1": {
    "value": "#fdfcfd",
    "variable": "var(--lmKOBi)"
  },
  "colors.gray.light.2": {
    "value": "#faf9fb",
    "variable": "var(--gwftzd)"
  },
  "colors.gray.light.3": {
    "value": "#f2eff3",
    "variable": "var(--fbTYQE)"
  },
  "colors.gray.light.4": {
    "value": "#eae7ec",
    "variable": "var(--epwTfT)"
  },
  "colors.gray.light.5": {
    "value": "#e3dfe6",
    "variable": "var(--cVlyxu)"
  },
  "colors.gray.light.6": {
    "value": "#dbd8e0",
    "variable": "var(--jubMUl)"
  },
  "colors.gray.light.7": {
    "value": "#d0cdd7",
    "variable": "var(--hZQslM)"
  },
  "colors.gray.light.8": {
    "value": "#bcbac7",
    "variable": "var(--cQNCQf)"
  },
  "colors.gray.light.9": {
    "value": "#8e8c99",
    "variable": "var(--bwCihG)"
  },
  "colors.gray.light.10": {
    "value": "#84828e",
    "variable": "var(--geWGVi)"
  },
  "colors.gray.light.11": {
    "value": "#65636d",
    "variable": "var(--cWABjX)"
  },
  "colors.gray.light.12": {
    "value": "#211f26",
    "variable": "var(--bdVmeg)"
  },
  "colors.gray.light.a1": {
    "value": "#55005503",
    "variable": "var(--elVOXX)"
  },
  "colors.gray.light.a2": {
    "value": "#2b005506",
    "variable": "var(--UzZcU)"
  },
  "colors.gray.light.a3": {
    "value": "#30004010",
    "variable": "var(--jgsfYV)"
  },
  "colors.gray.light.a4": {
    "value": "#20003618",
    "variable": "var(--fwSfoy)"
  },
  "colors.gray.light.a5": {
    "value": "#20003820",
    "variable": "var(--ctoCLD)"
  },
  "colors.gray.light.a6": {
    "value": "#14003527",
    "variable": "var(--krowpw)"
  },
  "colors.gray.light.a7": {
    "value": "#10003332",
    "variable": "var(--hnKTMB)"
  },
  "colors.gray.light.a8": {
    "value": "#08003145",
    "variable": "var(--hgxWwu)"
  },
  "colors.gray.light.a9": {
    "value": "#05001d73",
    "variable": "var(--ecUtTz)"
  },
  "colors.gray.light.a10": {
    "value": "#0500197d",
    "variable": "var(--fvuVcD)"
  },
  "colors.gray.light.a11": {
    "value": "#0400119c",
    "variable": "var(--kKubVy)"
  },
  "colors.gray.light.a12": {
    "value": "#020008e0",
    "variable": "var(--cXfXVB)"
  },
  "colors.gray.dark.1": {
    "value": "#121113",
    "variable": "var(--lgQjRA)"
  },
  "colors.gray.dark.2": {
    "value": "#1a191b",
    "variable": "var(--krndNP)"
  },
  "colors.gray.dark.3": {
    "value": "#232225",
    "variable": "var(--vrOeu)"
  },
  "colors.gray.dark.4": {
    "value": "#2b292d",
    "variable": "var(--jeBxcR)"
  },
  "colors.gray.dark.5": {
    "value": "#323035",
    "variable": "var(--kybQSs)"
  },
  "colors.gray.dark.6": {
    "value": "#3c393f",
    "variable": "var(--jIyKOH)"
  },
  "colors.gray.dark.7": {
    "value": "#49474e",
    "variable": "var(--lbZeEi)"
  },
  "colors.gray.dark.8": {
    "value": "#625f69",
    "variable": "var(--dZDBFt)"
  },
  "colors.gray.dark.9": {
    "value": "#6f6d78",
    "variable": "var(--ftdVuU)"
  },
  "colors.gray.dark.10": {
    "value": "#7c7a85",
    "variable": "var(--mdPEo)"
  },
  "colors.gray.dark.11": {
    "value": "#b5b2bc",
    "variable": "var(--inmDDd)"
  },
  "colors.gray.dark.12": {
    "value": "#eeeef0",
    "variable": "var(--bAYuxi)"
  },
  "colors.gray.dark.a1": {
    "value": "#00000000",
    "variable": "var(--gyLqOh)"
  },
  "colors.gray.dark.a2": {
    "value": "#f5f4f609",
    "variable": "var(--kCRjqu)"
  },
  "colors.gray.dark.a3": {
    "value": "#ebeaf814",
    "variable": "var(--gypLMD)"
  },
  "colors.gray.dark.a4": {
    "value": "#eee5f81d",
    "variable": "var(--jvdXnU)"
  },
  "colors.gray.dark.a5": {
    "value": "#efe6fe25",
    "variable": "var(--fqCzKd)"
  },
  "colors.gray.dark.a6": {
    "value": "#f1e6fd30",
    "variable": "var(--juIsmq)"
  },
  "colors.gray.dark.a7": {
    "value": "#eee9ff40",
    "variable": "var(--fqgUIz)"
  },
  "colors.gray.dark.a8": {
    "value": "#eee7ff5d",
    "variable": "var(--fOpwfk)"
  },
  "colors.gray.dark.a9": {
    "value": "#eae6fd6e",
    "variable": "var(--bJNYBt)"
  },
  "colors.gray.dark.a10": {
    "value": "#ece9fd7c",
    "variable": "var(--bWtcft)"
  },
  "colors.gray.dark.a11": {
    "value": "#f5f1ffb7",
    "variable": "var(--dnociw)"
  },
  "colors.gray.dark.a12": {
    "value": "#fdfdffef",
    "variable": "var(--xxAvr)"
  },
  "colors.pink.light.1": {
    "value": "#fffcfe",
    "variable": "var(--kRPUJz)"
  },
  "colors.pink.light.2": {
    "value": "#fef7fb",
    "variable": "var(--ipaxew)"
  },
  "colors.pink.light.3": {
    "value": "#fee9f5",
    "variable": "var(--jEBLRl)"
  },
  "colors.pink.light.4": {
    "value": "#fbdcef",
    "variable": "var(--efFPjS)"
  },
  "colors.pink.light.5": {
    "value": "#f6cee7",
    "variable": "var(--fvhdWH)"
  },
  "colors.pink.light.6": {
    "value": "#efbfdd",
    "variable": "var(--cSrGrE)"
  },
  "colors.pink.light.7": {
    "value": "#e7acd0",
    "variable": "var(--ehSVet)"
  },
  "colors.pink.light.8": {
    "value": "#dd93c2",
    "variable": "var(--cxkFW)"
  },
  "colors.pink.light.9": {
    "value": "#d6409f",
    "variable": "var(--brYzsL)"
  },
  "colors.pink.light.10": {
    "value": "#cf3897",
    "variable": "var(--hpXnOv)"
  },
  "colors.pink.light.11": {
    "value": "#c2298a",
    "variable": "var(--kCQhDq)"
  },
  "colors.pink.light.12": {
    "value": "#651249",
    "variable": "var(--nZHbd)"
  },
  "colors.pink.light.a1": {
    "value": "#ff00aa03",
    "variable": "var(--jVbDrW)"
  },
  "colors.pink.light.a2": {
    "value": "#e0008008",
    "variable": "var(--fxhMdB)"
  },
  "colors.pink.light.a3": {
    "value": "#f4008c16",
    "variable": "var(--deiqmg)"
  },
  "colors.pink.light.a4": {
    "value": "#e2008b23",
    "variable": "var(--caOCOX)"
  },
  "colors.pink.light.a5": {
    "value": "#d1008331",
    "variable": "var(--kXkQwy)"
  },
  "colors.pink.light.a6": {
    "value": "#c0007840",
    "variable": "var(--gzqZid)"
  },
  "colors.pink.light.a7": {
    "value": "#b6006f53",
    "variable": "var(--egrDqI)"
  },
  "colors.pink.light.a8": {
    "value": "#af006f6c",
    "variable": "var(--bfVfIL)"
  },
  "colors.pink.light.a9": {
    "value": "#c8007fbf",
    "variable": "var(--kcrtqm)"
  },
  "colors.pink.light.a10": {
    "value": "#c2007ac7",
    "variable": "var(--bvaAIC)"
  },
  "colors.pink.light.a11": {
    "value": "#b60074d6",
    "variable": "var(--dzOxPH)"
  },
  "colors.pink.light.a12": {
    "value": "#59003bed",
    "variable": "var(--iCzssE)"
  },
  "colors.pink.dark.1": {
    "value": "#191117",
    "variable": "var(--gfmqsp)"
  },
  "colors.pink.dark.2": {
    "value": "#21121d",
    "variable": "var(--hmFAAS)"
  },
  "colors.pink.dark.3": {
    "value": "#37172f",
    "variable": "var(--cUmsMD)"
  },
  "colors.pink.dark.4": {
    "value": "#4b143d",
    "variable": "var(--bulUZw)"
  },
  "colors.pink.dark.5": {
    "value": "#591c47",
    "variable": "var(--irowKd)"
  },
  "colors.pink.dark.6": {
    "value": "#692955",
    "variable": "var(--jyHGSG)"
  },
  "colors.pink.dark.7": {
    "value": "#833869",
    "variable": "var(--fgozer)"
  },
  "colors.pink.dark.8": {
    "value": "#a84885",
    "variable": "var(--fakuMM)"
  },
  "colors.pink.dark.9": {
    "value": "#d6409f",
    "variable": "var(--HRmYx)"
  },
  "colors.pink.dark.10": {
    "value": "#de51a8",
    "variable": "var(--ifRgoV)"
  },
  "colors.pink.dark.11": {
    "value": "#ff8dcc",
    "variable": "var(--dQYoBk)"
  },
  "colors.pink.dark.12": {
    "value": "#fdd1ea",
    "variable": "var(--khTXef)"
  },
  "colors.pink.dark.a1": {
    "value": "#f412bc09",
    "variable": "var(--kyjkAo)"
  },
  "colors.pink.dark.a2": {
    "value": "#f420bb12",
    "variable": "var(--bMqezH)"
  },
  "colors.pink.dark.a3": {
    "value": "#fe37cc29",
    "variable": "var(--RZQHG)"
  },
  "colors.pink.dark.a4": {
    "value": "#fc1ec43f",
    "variable": "var(--bPLxgl)"
  },
  "colors.pink.dark.a5": {
    "value": "#fd35c24e",
    "variable": "var(--Vvjok)"
  },
  "colors.pink.dark.a6": {
    "value": "#fd51c75f",
    "variable": "var(--dyXMMz)"
  },
  "colors.pink.dark.a7": {
    "value": "#fd62c87b",
    "variable": "var(--cEHyUy)"
  },
  "colors.pink.dark.a8": {
    "value": "#ff68c8a2",
    "variable": "var(--gTTrip)"
  },
  "colors.pink.dark.a9": {
    "value": "#fe49bcd4",
    "variable": "var(--fZDdqo)"
  },
  "colors.pink.dark.a10": {
    "value": "#ff5cc0dc",
    "variable": "var(--hBMwCw)"
  },
  "colors.pink.dark.a11": {
    "value": "#ff8dcc",
    "variable": "var(--cxsxft)"
  },
  "colors.pink.dark.a12": {
    "value": "#ffd3ecfd",
    "variable": "var(--idNgOK)"
  },
  "colors.ll.1": {
    "value": "#170e11",
    "variable": "var(--fYWzUY)"
  },
  "colors.ll.2": {
    "value": "#211217",
    "variable": "var(--husVVD)"
  },
  "colors.ll.3": {
    "value": "#3c1223",
    "variable": "var(--jtsOcW)"
  },
  "colors.ll.4": {
    "value": "#53082c",
    "variable": "var(--ipecBd)"
  },
  "colors.ll.5": {
    "value": "#620f36",
    "variable": "var(--kodUIw)"
  },
  "colors.ll.6": {
    "value": "#731d43",
    "variable": "var(--ueHkf)"
  },
  "colors.ll.7": {
    "value": "#8e2c56",
    "variable": "var(--ctezry)"
  },
  "colors.ll.8": {
    "value": "#b7386f",
    "variable": "var(--gLdBLF)"
  },
  "colors.ll.9": {
    "value": "#e4007f",
    "variable": "var(--iKdtSY)"
  },
  "colors.ll.10": {
    "value": "#d40072",
    "variable": "var(--fNaRxU)"
  },
  "colors.ll.11": {
    "value": "#ff87b8",
    "variable": "var(--sVqcd)"
  },
  "colors.ll.12": {
    "value": "#ffd0e0",
    "variable": "var(--bAYMZm)"
  },
  "colors.ll.a1": {
    "value": "#ec001207",
    "variable": "var(--isOwEd)"
  },
  "colors.ll.a2": {
    "value": "#f4206612",
    "variable": "var(--jMlrMq)"
  },
  "colors.ll.a3": {
    "value": "#fb17732f",
    "variable": "var(--bxcStD)"
  },
  "colors.ll.a4": {
    "value": "#ff007247",
    "variable": "var(--bXETNI)"
  },
  "colors.ll.a5": {
    "value": "#ff0c7e57",
    "variable": "var(--eXSdTR)"
  },
  "colors.ll.a6": {
    "value": "#ff2f8b69",
    "variable": "var(--groZce)"
  },
  "colors.ll.a7": {
    "value": "#ff459586",
    "variable": "var(--jrCjin)"
  },
  "colors.ll.a8": {
    "value": "#ff4998b2",
    "variable": "var(--SYotw)"
  },
  "colors.ll.a9": {
    "value": "#fe008ce3",
    "variable": "var(--dTlyzF)"
  },
  "colors.ll.a10": {
    "value": "#ff0088d1",
    "variable": "var(--nvJDx)"
  },
  "colors.ll.a11": {
    "value": "#ff87b8",
    "variable": "var(--gaCmcc)"
  },
  "colors.ll.a12": {
    "value": "#ffd0e0",
    "variable": "var(--gxrOGP)"
  },
  "breakpoints.sm": {
    "value": "640px",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "768px",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "1024px",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "1280px",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--dgHGKE)"
  },
  "radii.l1": {
    "value": "var(--kLOfAE)",
    "variable": "var(--fTYdTU)"
  },
  "radii.l2": {
    "value": "var(--dxfumK)",
    "variable": "var(--gIVWVv)"
  },
  "radii.l3": {
    "value": "var(--UXfgJ)",
    "variable": "var(--kqvVrC)"
  },
  "colors.accent.1": {
    "value": "var(--fYWzUY)",
    "variable": "var(--hAdGwm)"
  },
  "colors.accent.2": {
    "value": "var(--husVVD)",
    "variable": "var(--fSAgex)"
  },
  "colors.accent.3": {
    "value": "var(--jtsOcW)",
    "variable": "var(--coAyOM)"
  },
  "colors.accent.4": {
    "value": "var(--ipecBd)",
    "variable": "var(--gvRbFL)"
  },
  "colors.accent.5": {
    "value": "var(--kodUIw)",
    "variable": "var(--cRRuqa)"
  },
  "colors.accent.6": {
    "value": "var(--ueHkf)",
    "variable": "var(--bknTYl)"
  },
  "colors.accent.7": {
    "value": "var(--ctezry)",
    "variable": "var(--iVJWhw)"
  },
  "colors.accent.8": {
    "value": "var(--gLdBLF)",
    "variable": "var(--hfhoTj)"
  },
  "colors.accent.9": {
    "value": "var(--iKdtSY)",
    "variable": "var(--dBhHDy)"
  },
  "colors.accent.10": {
    "value": "var(--fNaRxU)",
    "variable": "var(--detqkm)"
  },
  "colors.accent.11": {
    "value": "var(--sVqcd)",
    "variable": "var(--jufVdP)"
  },
  "colors.accent.12": {
    "value": "var(--bAYMZm)",
    "variable": "var(--bdsMbc)"
  },
  "colors.accent.a1": {
    "value": "var(--isOwEd)",
    "variable": "var(--kXOVED)"
  },
  "colors.accent.a2": {
    "value": "var(--jMlrMq)",
    "variable": "var(--enxCTI)"
  },
  "colors.accent.a3": {
    "value": "var(--bxcStD)",
    "variable": "var(--ilgQqh)"
  },
  "colors.accent.a4": {
    "value": "var(--bXETNI)",
    "variable": "var(--gvGSMi)"
  },
  "colors.accent.a5": {
    "value": "var(--eXSdTR)",
    "variable": "var(--ktqgiH)"
  },
  "colors.accent.a6": {
    "value": "var(--groZce)",
    "variable": "var(--dIYNxM)"
  },
  "colors.accent.a7": {
    "value": "var(--jrCjin)",
    "variable": "var(--hGIaUl)"
  },
  "colors.accent.a8": {
    "value": "var(--SYotw)",
    "variable": "var(--gjeztG)"
  },
  "colors.accent.a9": {
    "value": "var(--dTlyzF)",
    "variable": "var(--kgNMQf)"
  },
  "colors.accent.a10": {
    "value": "var(--nvJDx)",
    "variable": "var(--hfveQT)"
  },
  "colors.accent.a11": {
    "value": "var(--gaCmcc)",
    "variable": "var(--efUAWu)"
  },
  "colors.accent.a12": {
    "value": "var(--gxrOGP)",
    "variable": "var(--ixYDyh)"
  },
  "colors.accent.default": {
    "value": "var(--iKdtSY)",
    "variable": "var(--dnAAhs)"
  },
  "colors.accent.emphasized": {
    "value": "var(--fNaRxU)",
    "variable": "var(--cYYxav)"
  },
  "colors.accent.fg": {
    "value": "var(--RiClf)",
    "variable": "var(--cbmUMC)"
  },
  "colors.accent.text": {
    "value": "var(--gaCmcc)",
    "variable": "var(--fuSTIW)"
  },
  "spacing.-1": {
    "value": "calc(var(--dacYEG) * -1)",
    "variable": "var(--dacYEG)"
  },
  "spacing.-2": {
    "value": "calc(var(--ebuyxV) * -1)",
    "variable": "var(--ebuyxV)"
  },
  "spacing.-3": {
    "value": "calc(var(--bYDCFo) * -1)",
    "variable": "var(--bYDCFo)"
  },
  "spacing.-4": {
    "value": "calc(var(--hIimNX) * -1)",
    "variable": "var(--hIimNX)"
  },
  "spacing.-5": {
    "value": "calc(var(--fFrqVq) * -1)",
    "variable": "var(--fFrqVq)"
  },
  "spacing.-6": {
    "value": "calc(var(--gGIQOF) * -1)",
    "variable": "var(--gGIQOF)"
  },
  "spacing.-7": {
    "value": "calc(var(--eDRUVY) * -1)",
    "variable": "var(--eDRUVY)"
  },
  "spacing.-8": {
    "value": "calc(var(--flZesP) * -1)",
    "variable": "var(--flZesP)"
  },
  "spacing.-9": {
    "value": "calc(var(--djiiAi) * -1)",
    "variable": "var(--djiiAi)"
  },
  "spacing.-10": {
    "value": "calc(var(--ieMJEa) * -1)",
    "variable": "var(--ieMJEa)"
  },
  "spacing.-11": {
    "value": "calc(var(--cBFxYr) * -1)",
    "variable": "var(--cBFxYr)"
  },
  "spacing.-12": {
    "value": "calc(var(--uyqLg) * -1)",
    "variable": "var(--uyqLg)"
  },
  "spacing.-14": {
    "value": "calc(var(--hXmVPi) * -1)",
    "variable": "var(--hXmVPi)"
  },
  "spacing.-16": {
    "value": "calc(var(--mYCWo) * -1)",
    "variable": "var(--mYCWo)"
  },
  "spacing.-20": {
    "value": "calc(var(--jgejxp) * -1)",
    "variable": "var(--jgejxp)"
  },
  "spacing.-24": {
    "value": "calc(var(--iYEvIx) * -1)",
    "variable": "var(--iYEvIx)"
  },
  "spacing.-28": {
    "value": "calc(var(--dzpWeZ) * -1)",
    "variable": "var(--dzpWeZ)"
  },
  "spacing.-32": {
    "value": "calc(var(--fifqnK) * -1)",
    "variable": "var(--fifqnK)"
  },
  "spacing.-36": {
    "value": "calc(var(--faFCyS) * -1)",
    "variable": "var(--faFCyS)"
  },
  "spacing.-40": {
    "value": "calc(var(--bxwoov) * -1)",
    "variable": "var(--bxwoov)"
  },
  "spacing.-44": {
    "value": "calc(var(--huPzrf) * -1)",
    "variable": "var(--huPzrf)"
  },
  "spacing.-48": {
    "value": "calc(var(--hgdKvb) * -1)",
    "variable": "var(--hgdKvb)"
  },
  "spacing.-52": {
    "value": "calc(var(--cZMJbQ) * -1)",
    "variable": "var(--cZMJbQ)"
  },
  "spacing.-56": {
    "value": "calc(var(--iXfUeA) * -1)",
    "variable": "var(--iXfUeA)"
  },
  "spacing.-60": {
    "value": "calc(var(--vWSpd) * -1)",
    "variable": "var(--vWSpd)"
  },
  "spacing.-64": {
    "value": "calc(var(--gtqdrN) * -1)",
    "variable": "var(--gtqdrN)"
  },
  "spacing.-72": {
    "value": "calc(var(--hNtIEu) * -1)",
    "variable": "var(--hNtIEu)"
  },
  "spacing.-80": {
    "value": "calc(var(--kqIPsj) * -1)",
    "variable": "var(--kqIPsj)"
  },
  "spacing.-96": {
    "value": "calc(var(--wdMRQ) * -1)",
    "variable": "var(--wdMRQ)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--gEfgCY) * -1)",
    "variable": "var(--gEfgCY)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--jJIQbV) * -1)",
    "variable": "var(--jJIQbV)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--cqwGG) * -1)",
    "variable": "var(--cqwGG)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--dhUgfD) * -1)",
    "variable": "var(--dhUgfD)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--jjtyTI) * -1)",
    "variable": "var(--jjtyTI)"
  },
  "shadows.xs": {
    "value": "var(--bUWovs)",
    "variable": "var(--bUWovs)"
  },
  "shadows.sm": {
    "value": "var(--cDhNnp)",
    "variable": "var(--cDhNnp)"
  },
  "shadows.md": {
    "value": "var(--jMKUKK)",
    "variable": "var(--jMKUKK)"
  },
  "shadows.lg": {
    "value": "var(--kNVcRA)",
    "variable": "var(--kNVcRA)"
  },
  "shadows.xl": {
    "value": "var(--bnVgij)",
    "variable": "var(--bnVgij)"
  },
  "shadows.2xl": {
    "value": "var(--IghlV)",
    "variable": "var(--IghlV)"
  },
  "colors.bg.canvas": {
    "value": "var(--jyeInc)",
    "variable": "var(--jyeInc)"
  },
  "colors.bg.default": {
    "value": "var(--dAHamv)",
    "variable": "var(--dAHamv)"
  },
  "colors.bg.subtle": {
    "value": "var(--iqsEix)",
    "variable": "var(--iqsEix)"
  },
  "colors.bg.muted": {
    "value": "var(--cwRYAB)",
    "variable": "var(--cwRYAB)"
  },
  "colors.bg.emphasized": {
    "value": "var(--dYITcM)",
    "variable": "var(--dYITcM)"
  },
  "colors.bg.disabled": {
    "value": "var(--ekfnOU)",
    "variable": "var(--ekfnOU)"
  },
  "colors.fg.default": {
    "value": "var(--oFQWH)",
    "variable": "var(--oFQWH)"
  },
  "colors.fg.muted": {
    "value": "var(--fIThQp)",
    "variable": "var(--fIThQp)"
  },
  "colors.fg.subtle": {
    "value": "var(--feruSJ)",
    "variable": "var(--feruSJ)"
  },
  "colors.fg.disabled": {
    "value": "var(--Yeezg)",
    "variable": "var(--Yeezg)"
  },
  "colors.fg.error": {
    "value": "var(--bINVEQ)",
    "variable": "var(--bINVEQ)"
  },
  "colors.border.default": {
    "value": "var(--jYZtFW)",
    "variable": "var(--jYZtFW)"
  },
  "colors.border.muted": {
    "value": "var(--hWIGgY)",
    "variable": "var(--hWIGgY)"
  },
  "colors.border.subtle": {
    "value": "var(--jfPAjk)",
    "variable": "var(--jfPAjk)"
  },
  "colors.border.disabled": {
    "value": "var(--fuGbd)",
    "variable": "var(--fuGbd)"
  },
  "colors.border.outline": {
    "value": "var(--goYiXt)",
    "variable": "var(--goYiXt)"
  },
  "colors.border.error": {
    "value": "var(--caovhJ)",
    "variable": "var(--caovhJ)"
  },
  "colors.red.1": {
    "value": "var(--etxQkH)",
    "variable": "var(--etxQkH)"
  },
  "colors.red.2": {
    "value": "var(--uuLzg)",
    "variable": "var(--uuLzg)"
  },
  "colors.red.3": {
    "value": "var(--ewlKOR)",
    "variable": "var(--ewlKOR)"
  },
  "colors.red.4": {
    "value": "var(--gfTKOm)",
    "variable": "var(--gfTKOm)"
  },
  "colors.red.5": {
    "value": "var(--khKKdX)",
    "variable": "var(--khKKdX)"
  },
  "colors.red.6": {
    "value": "var(--giHFsw)",
    "variable": "var(--giHFsw)"
  },
  "colors.red.7": {
    "value": "var(--kkyEIh)",
    "variable": "var(--kkyEIh)"
  },
  "colors.red.8": {
    "value": "var(--uTXKa)",
    "variable": "var(--uTXKa)"
  },
  "colors.red.9": {
    "value": "var(--ewKWZL)",
    "variable": "var(--ewKWZL)"
  },
  "colors.red.10": {
    "value": "var(--hjWhpD)",
    "variable": "var(--hjWhpD)"
  },
  "colors.red.11": {
    "value": "var(--kJdFvK)",
    "variable": "var(--kJdFvK)"
  },
  "colors.red.12": {
    "value": "var(--dKoaEd)",
    "variable": "var(--dKoaEd)"
  },
  "colors.red.a1": {
    "value": "var(--fODDHe)",
    "variable": "var(--fODDHe)"
  },
  "colors.red.a2": {
    "value": "var(--ffeSNF)",
    "variable": "var(--ffeSNF)"
  },
  "colors.red.a3": {
    "value": "var(--deIfDw)",
    "variable": "var(--deIfDw)"
  },
  "colors.red.a4": {
    "value": "var(--ikcjlb)",
    "variable": "var(--ikcjlb)"
  },
  "colors.red.a5": {
    "value": "var(--gjFwaS)",
    "variable": "var(--gjFwaS)"
  },
  "colors.red.a6": {
    "value": "var(--fAgLht)",
    "variable": "var(--fAgLht)"
  },
  "colors.red.a7": {
    "value": "var(--dzJXXk)",
    "variable": "var(--dzJXXk)"
  },
  "colors.red.a8": {
    "value": "var(--hpnRgz)",
    "variable": "var(--hpnRgz)"
  },
  "colors.red.a9": {
    "value": "var(--foRdWq)",
    "variable": "var(--foRdWq)"
  },
  "colors.red.a10": {
    "value": "var(--iDYKay)",
    "variable": "var(--iDYKay)"
  },
  "colors.red.a11": {
    "value": "var(--dnbgWz)",
    "variable": "var(--dnbgWz)"
  },
  "colors.red.a12": {
    "value": "var(--iMzxyk)",
    "variable": "var(--iMzxyk)"
  },
  "colors.red.default": {
    "value": "var(--oTHuZ)",
    "variable": "var(--oTHuZ)"
  },
  "colors.red.emphasized": {
    "value": "var(--ipndKO)",
    "variable": "var(--ipndKO)"
  },
  "colors.red.fg": {
    "value": "var(--gKoSUH)",
    "variable": "var(--gKoSUH)"
  },
  "colors.red.text": {
    "value": "var(--dOlSon)",
    "variable": "var(--dOlSon)"
  },
  "colors.gray.1": {
    "value": "var(--gvebIF)",
    "variable": "var(--gvebIF)"
  },
  "colors.gray.2": {
    "value": "var(--eTpLjW)",
    "variable": "var(--eTpLjW)"
  },
  "colors.gray.3": {
    "value": "var(--dsegiv)",
    "variable": "var(--dsegiv)"
  },
  "colors.gray.4": {
    "value": "var(--ihAGY)",
    "variable": "var(--ihAGY)"
  },
  "colors.gray.5": {
    "value": "var(--jWrFet)",
    "variable": "var(--jWrFet)"
  },
  "colors.gray.6": {
    "value": "var(--iuDoFK)",
    "variable": "var(--iuDoFK)"
  },
  "colors.gray.7": {
    "value": "var(--gTrJEj)",
    "variable": "var(--gTrJEj)"
  },
  "colors.gray.8": {
    "value": "var(--hqcTvk)",
    "variable": "var(--hqcTvk)"
  },
  "colors.gray.9": {
    "value": "var(--fORotJ)",
    "variable": "var(--fORotJ)"
  },
  "colors.gray.10": {
    "value": "var(--kQuIMV)",
    "variable": "var(--kQuIMV)"
  },
  "colors.gray.11": {
    "value": "var(--jbnCQE)",
    "variable": "var(--jbnCQE)"
  },
  "colors.gray.12": {
    "value": "var(--cwPjUD)",
    "variable": "var(--cwPjUD)"
  },
  "colors.gray.a1": {
    "value": "var(--bnYjlQ)",
    "variable": "var(--bnYjlQ)"
  },
  "colors.gray.a2": {
    "value": "var(--cTUQvX)",
    "variable": "var(--cTUQvX)"
  },
  "colors.gray.a3": {
    "value": "var(--iIbQvq)",
    "variable": "var(--iIbQvq)"
  },
  "colors.gray.a4": {
    "value": "var(--cDNLgl)",
    "variable": "var(--cDNLgl)"
  },
  "colors.gray.a5": {
    "value": "var(--irULfE)",
    "variable": "var(--irULfE)"
  },
  "colors.gray.a6": {
    "value": "var(--jXRspL)",
    "variable": "var(--jXRspL)"
  },
  "colors.gray.a7": {
    "value": "var(--ewCIQi)",
    "variable": "var(--ewCIQi)"
  },
  "colors.gray.a8": {
    "value": "var(--ktdRZt)",
    "variable": "var(--ktdRZt)"
  },
  "colors.gray.a9": {
    "value": "var(--eRPizQ)",
    "variable": "var(--eRPizQ)"
  },
  "colors.gray.a10": {
    "value": "var(--fanazs)",
    "variable": "var(--fanazs)"
  },
  "colors.gray.a11": {
    "value": "var(--jKUQXt)",
    "variable": "var(--jKUQXt)"
  },
  "colors.gray.a12": {
    "value": "var(--gVADwC)",
    "variable": "var(--gVADwC)"
  },
  "colors.gray.default": {
    "value": "var(--hxODP)",
    "variable": "var(--hxODP)"
  },
  "colors.gray.emphasized": {
    "value": "var(--bbMUAU)",
    "variable": "var(--bbMUAU)"
  },
  "colors.gray.fg": {
    "value": "var(--cnFVQV)",
    "variable": "var(--cnFVQV)"
  },
  "colors.gray.text": {
    "value": "var(--eUmUWB)",
    "variable": "var(--eUmUWB)"
  },
  "colors.pink.1": {
    "value": "var(--jTUFYU)",
    "variable": "var(--jTUFYU)"
  },
  "colors.pink.2": {
    "value": "var(--geqsdj)",
    "variable": "var(--geqsdj)"
  },
  "colors.pink.3": {
    "value": "var(--bTsdGu)",
    "variable": "var(--bTsdGu)"
  },
  "colors.pink.4": {
    "value": "var(--jlBnJx)",
    "variable": "var(--jlBnJx)"
  },
  "colors.pink.5": {
    "value": "var(--faCZmI)",
    "variable": "var(--faCZmI)"
  },
  "colors.pink.6": {
    "value": "var(--bkYLqX)",
    "variable": "var(--bkYLqX)"
  },
  "colors.pink.7": {
    "value": "var(--ipwgte)",
    "variable": "var(--ipwgte)"
  },
  "colors.pink.8": {
    "value": "var(--czBIKF)",
    "variable": "var(--czBIKF)"
  },
  "colors.pink.9": {
    "value": "var(--jDZdMM)",
    "variable": "var(--jDZdMM)"
  },
  "colors.pink.10": {
    "value": "var(--btUcTs)",
    "variable": "var(--btUcTs)"
  },
  "colors.pink.11": {
    "value": "var(--jQAmQV)",
    "variable": "var(--jQAmQV)"
  },
  "colors.pink.12": {
    "value": "var(--kBxFvG)",
    "variable": "var(--kBxFvG)"
  },
  "colors.pink.a1": {
    "value": "var(--jhLzWx)",
    "variable": "var(--jhLzWx)"
  },
  "colors.pink.a2": {
    "value": "var(--bviNTW)",
    "variable": "var(--bviNTW)"
  },
  "colors.pink.a3": {
    "value": "var(--bxwmpz)",
    "variable": "var(--bxwmpz)"
  },
  "colors.pink.a4": {
    "value": "var(--hOPtmI)",
    "variable": "var(--hOPtmI)"
  },
  "colors.pink.a5": {
    "value": "var(--hRcRIl)",
    "variable": "var(--hRcRIl)"
  },
  "colors.pink.a6": {
    "value": "var(--eAfFK)",
    "variable": "var(--eAfFK)"
  },
  "colors.pink.a7": {
    "value": "var(--gNEbn)",
    "variable": "var(--gNEbn)"
  },
  "colors.pink.a8": {
    "value": "var(--bKkCsM)",
    "variable": "var(--bKkCsM)"
  },
  "colors.pink.a9": {
    "value": "var(--bMyaOp)",
    "variable": "var(--bMyaOp)"
  },
  "colors.pink.a10": {
    "value": "var(--loeQzd)",
    "variable": "var(--loeQzd)"
  },
  "colors.pink.a11": {
    "value": "var(--dILbkE)",
    "variable": "var(--dILbkE)"
  },
  "colors.pink.a12": {
    "value": "var(--cHeVTH)",
    "variable": "var(--cHeVTH)"
  },
  "colors.pink.default": {
    "value": "var(--iCxvhG)",
    "variable": "var(--iCxvhG)"
  },
  "colors.pink.emphasized": {
    "value": "var(--lRpxR)",
    "variable": "var(--lRpxR)"
  },
  "colors.pink.fg": {
    "value": "var(--gndPDc)",
    "variable": "var(--gndPDc)"
  },
  "colors.pink.text": {
    "value": "var(--dJgqos)",
    "variable": "var(--dJgqos)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.a1": {
    "value": "var(--gEjGXh)",
    "variable": "var(--gEjGXh)"
  },
  "colors.colorPalette.a2": {
    "value": "var(--kLNOfu)",
    "variable": "var(--kLNOfu)"
  },
  "colors.colorPalette.a3": {
    "value": "var(--kcWzyj)",
    "variable": "var(--kcWzyj)"
  },
  "colors.colorPalette.a4": {
    "value": "var(--bmkpYg)",
    "variable": "var(--bmkpYg)"
  },
  "colors.colorPalette.a5": {
    "value": "var(--DtbqV)",
    "variable": "var(--DtbqV)"
  },
  "colors.colorPalette.a6": {
    "value": "var(--eKXizi)",
    "variable": "var(--eKXizi)"
  },
  "colors.colorPalette.a7": {
    "value": "var(--ecfTRX)",
    "variable": "var(--ecfTRX)"
  },
  "colors.colorPalette.a8": {
    "value": "var(--brNygA)",
    "variable": "var(--brNygA)"
  },
  "colors.colorPalette.a9": {
    "value": "var(--IWjzp)",
    "variable": "var(--IWjzp)"
  },
  "colors.colorPalette.a10": {
    "value": "var(--blVylV)",
    "variable": "var(--blVylV)"
  },
  "colors.colorPalette.a11": {
    "value": "var(--fPNFDw)",
    "variable": "var(--fPNFDw)"
  },
  "colors.colorPalette.a12": {
    "value": "var(--bEUhnv)",
    "variable": "var(--bEUhnv)"
  },
  "colors.colorPalette.light.1": {
    "value": "var(--iYbJpn)",
    "variable": "var(--iYbJpn)"
  },
  "colors.colorPalette.1": {
    "value": "var(--ldjTvg)",
    "variable": "var(--ldjTvg)"
  },
  "colors.colorPalette.light.2": {
    "value": "var(--kCAnZE)",
    "variable": "var(--kCAnZE)"
  },
  "colors.colorPalette.2": {
    "value": "var(--dohdfL)",
    "variable": "var(--dohdfL)"
  },
  "colors.colorPalette.light.3": {
    "value": "var(--fvkcjx)",
    "variable": "var(--fvkcjx)"
  },
  "colors.colorPalette.3": {
    "value": "var(--cOLUHe)",
    "variable": "var(--cOLUHe)"
  },
  "colors.colorPalette.light.4": {
    "value": "var(--fWxiwu)",
    "variable": "var(--fWxiwu)"
  },
  "colors.colorPalette.4": {
    "value": "var(--fSvzFd)",
    "variable": "var(--fSvzFd)"
  },
  "colors.colorPalette.light.5": {
    "value": "var(--gvfanP)",
    "variable": "var(--gvfanP)"
  },
  "colors.colorPalette.5": {
    "value": "var(--kYYuNY)",
    "variable": "var(--kYYuNY)"
  },
  "colors.colorPalette.light.6": {
    "value": "var(--hZDEYg)",
    "variable": "var(--hZDEYg)"
  },
  "colors.colorPalette.6": {
    "value": "var(--djVEyD)",
    "variable": "var(--djVEyD)"
  },
  "colors.colorPalette.light.7": {
    "value": "var(--cSnthZ)",
    "variable": "var(--cSnthZ)"
  },
  "colors.colorPalette.7": {
    "value": "var(--cKAvZW)",
    "variable": "var(--cKAvZW)"
  },
  "colors.colorPalette.light.8": {
    "value": "var(--bDcbiq)",
    "variable": "var(--bDcbiq)"
  },
  "colors.colorPalette.8": {
    "value": "var(--kNaFOd)",
    "variable": "var(--kNaFOd)"
  },
  "colors.colorPalette.light.9": {
    "value": "var(--cbJSZL)",
    "variable": "var(--cbJSZL)"
  },
  "colors.colorPalette.9": {
    "value": "var(--eEhRyc)",
    "variable": "var(--eEhRyc)"
  },
  "colors.colorPalette.light.10": {
    "value": "var(--dTsgMb)",
    "variable": "var(--dTsgMb)"
  },
  "colors.colorPalette.10": {
    "value": "var(--bkzVmQ)",
    "variable": "var(--bkzVmQ)"
  },
  "colors.colorPalette.light.11": {
    "value": "var(--iXEiYq)",
    "variable": "var(--iXEiYq)"
  },
  "colors.colorPalette.11": {
    "value": "var(--jzaYHx)",
    "variable": "var(--jzaYHx)"
  },
  "colors.colorPalette.light.12": {
    "value": "var(--jmXHXx)",
    "variable": "var(--jmXHXx)"
  },
  "colors.colorPalette.12": {
    "value": "var(--emqGBm)",
    "variable": "var(--emqGBm)"
  },
  "colors.colorPalette.light.a1": {
    "value": "var(--cMYwai)",
    "variable": "var(--cMYwai)"
  },
  "colors.colorPalette.light.a2": {
    "value": "var(--cBaGkd)",
    "variable": "var(--cBaGkd)"
  },
  "colors.colorPalette.light.a3": {
    "value": "var(--fKMCPw)",
    "variable": "var(--fKMCPw)"
  },
  "colors.colorPalette.light.a4": {
    "value": "var(--loAfZH)",
    "variable": "var(--loAfZH)"
  },
  "colors.colorPalette.light.a5": {
    "value": "var(--diQtge)",
    "variable": "var(--diQtge)"
  },
  "colors.colorPalette.light.a6": {
    "value": "var(--cWSDpZ)",
    "variable": "var(--cWSDpZ)"
  },
  "colors.colorPalette.light.a7": {
    "value": "var(--ggEzVs)",
    "variable": "var(--ggEzVs)"
  },
  "colors.colorPalette.light.a8": {
    "value": "var(--joiPOr)",
    "variable": "var(--joiPOr)"
  },
  "colors.colorPalette.light.a9": {
    "value": "var(--bizcUO)",
    "variable": "var(--bizcUO)"
  },
  "colors.colorPalette.light.a10": {
    "value": "var(--hAXolC)",
    "variable": "var(--hAXolC)"
  },
  "colors.colorPalette.light.a11": {
    "value": "var(--jZircb)",
    "variable": "var(--jZircb)"
  },
  "colors.colorPalette.light.a12": {
    "value": "var(--eEHlak)",
    "variable": "var(--eEHlak)"
  },
  "colors.colorPalette.dark.1": {
    "value": "var(--bODUwt)",
    "variable": "var(--bODUwt)"
  },
  "colors.colorPalette.dark.2": {
    "value": "var(--kdgKSy)",
    "variable": "var(--kdgKSy)"
  },
  "colors.colorPalette.dark.3": {
    "value": "var(--kEPvFn)",
    "variable": "var(--kEPvFn)"
  },
  "colors.colorPalette.dark.4": {
    "value": "var(--fvahVs)",
    "variable": "var(--fvahVs)"
  },
  "colors.colorPalette.dark.5": {
    "value": "var(--fWISIh)",
    "variable": "var(--fWISIh)"
  },
  "colors.colorPalette.dark.6": {
    "value": "var(--cVPZFq)",
    "variable": "var(--cVPZFq)"
  },
  "colors.colorPalette.dark.7": {
    "value": "var(--dxyKsf)",
    "variable": "var(--dxyKsf)"
  },
  "colors.colorPalette.dark.8": {
    "value": "var(--htCEfE)",
    "variable": "var(--htCEfE)"
  },
  "colors.colorPalette.dark.9": {
    "value": "var(--hVloSt)",
    "variable": "var(--hVloSt)"
  },
  "colors.colorPalette.dark.10": {
    "value": "var(--gZJdRp)",
    "variable": "var(--gZJdRp)"
  },
  "colors.colorPalette.dark.11": {
    "value": "var(--kAXdTM)",
    "variable": "var(--kAXdTM)"
  },
  "colors.colorPalette.dark.12": {
    "value": "var(--cTpvwX)",
    "variable": "var(--cTpvwX)"
  },
  "colors.colorPalette.dark.a1": {
    "value": "var(--bUigyQ)",
    "variable": "var(--bUigyQ)"
  },
  "colors.colorPalette.dark.a2": {
    "value": "var(--jhcnzf)",
    "variable": "var(--jhcnzf)"
  },
  "colors.colorPalette.dark.a3": {
    "value": "var(--feFXLu)",
    "variable": "var(--feFXLu)"
  },
  "colors.colorPalette.dark.a4": {
    "value": "var(--eEZOJt)",
    "variable": "var(--eEZOJt)"
  },
  "colors.colorPalette.dark.a5": {
    "value": "var(--kWhNHk)",
    "variable": "var(--kWhNHk)"
  },
  "colors.colorPalette.dark.a6": {
    "value": "var(--gTGliD)",
    "variable": "var(--gTGliD)"
  },
  "colors.colorPalette.dark.a7": {
    "value": "var(--cRjVuS)",
    "variable": "var(--cRjVuS)"
  },
  "colors.colorPalette.dark.a8": {
    "value": "var(--dlnTCJ)",
    "variable": "var(--dlnTCJ)"
  },
  "colors.colorPalette.dark.a9": {
    "value": "var(--jCvSAA)",
    "variable": "var(--jCvSAA)"
  },
  "colors.colorPalette.dark.a10": {
    "value": "var(--cFEsPg)",
    "variable": "var(--cFEsPg)"
  },
  "colors.colorPalette.dark.a11": {
    "value": "var(--cmhzoZ)",
    "variable": "var(--cmhzoZ)"
  },
  "colors.colorPalette.dark.a12": {
    "value": "var(--gUtXyi)",
    "variable": "var(--gUtXyi)"
  },
  "colors.colorPalette.canvas": {
    "value": "var(--jsIbit)",
    "variable": "var(--jsIbit)"
  },
  "colors.colorPalette.default": {
    "value": "var(--bDjYrS)",
    "variable": "var(--bDjYrS)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--gXkkLU)",
    "variable": "var(--gXkkLU)"
  },
  "colors.colorPalette.muted": {
    "value": "var(--egAmRk)",
    "variable": "var(--egAmRk)"
  },
  "colors.colorPalette.emphasized": {
    "value": "var(--iFZgOB)",
    "variable": "var(--iFZgOB)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--gTYnIJ)",
    "variable": "var(--gTYnIJ)"
  },
  "colors.colorPalette.error": {
    "value": "var(--exqjmZ)",
    "variable": "var(--exqjmZ)"
  },
  "colors.colorPalette.outline": {
    "value": "var(--hOWBMd)",
    "variable": "var(--hOWBMd)"
  },
  "colors.colorPalette.fg": {
    "value": "var(--OpxuQ)",
    "variable": "var(--OpxuQ)"
  },
  "colors.colorPalette.text": {
    "value": "var(--yVRWg)",
    "variable": "var(--yVRWg)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar